import React from "react";
import classNames from "classnames";

import { ProductMarketplaceCategory } from "@/custom-types/Product";

import Image from "@/components/Image";

import { ProductBreadcrumbs } from "../ProductCategoryBreadcrumbs";

type HeroBannerProps = {
  category?: ProductMarketplaceCategory;
  imageSrc?: string;
  mobileImageSrc?: string;
  subcategory?: ProductMarketplaceCategory;
  subtitle?: string;
  title: string;
  useUpdatedHeroStyling: boolean;
};

export const HeroBanner: React.FC<HeroBannerProps> = ({
  category,
  imageSrc,
  mobileImageSrc,
  subcategory,
  subtitle,
  title,
  useUpdatedHeroStyling,
}) =>
  imageSrc || mobileImageSrc ? (
    <div
      className={classNames("relative ", {
        "h-[260px] md:h-[370px]": !useUpdatedHeroStyling,
      })}
      data-testid="hero-banner"
    >
      <div
        className={classNames(
          "container relative h-full flex flex-col justify-between z-[1]",
          {
            "text-default": useUpdatedHeroStyling,
            "text-white pb-lg md:pb-11": !useUpdatedHeroStyling,
          },
        )}
      >
        {!useUpdatedHeroStyling && (
          <ProductBreadcrumbs category={category} subcategory={subcategory} />
        )}
        <div
          className={classNames({
            "mt-lg": useUpdatedHeroStyling,
          })}
        >
          <h1
            className={classNames("heading--m", {
              "mb-sm": !useUpdatedHeroStyling,
              "mb-xs": useUpdatedHeroStyling,
            })}
          >
            {title}
          </h1>
          {subtitle && (
            <div
              className={classNames("dangerously-set-html mb-lg", {
                "text-default": useUpdatedHeroStyling,
                "text-white max-w-[420px]": !useUpdatedHeroStyling,
              })}
              dangerouslySetInnerHTML={{
                __html: subtitle,
              }}
            />
          )}
        </div>
      </div>
      {!useUpdatedHeroStyling && (
        <Image
          src={(imageSrc || mobileImageSrc) as string}
          mobileSrc={mobileImageSrc}
          alt=""
          className="z-0"
          sizes={[544, 767, 1023, 1440, null, 767]}
          background
          disableLazyLoad
          preload
        />
      )}
    </div>
  ) : (
    <section
      className={classNames("container", {
        "mt-sm": useUpdatedHeroStyling,
      })}
    >
      {!useUpdatedHeroStyling && (
        <ProductBreadcrumbs category={category} subcategory={subcategory} />
      )}
      <h1
        className={classNames({
          "mb-sm": !useUpdatedHeroStyling,
          "mb-xs": useUpdatedHeroStyling,
        })}
      >
        {title}
      </h1>
      {subtitle && (
        <div
          className="dangerously-set-html mb-md"
          dangerouslySetInnerHTML={{
            __html: subtitle,
          }}
        />
      )}
    </section>
  );
